"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _MaterialSpecularGlossinessData_glossiness, _MaterialSpecularGlossinessData_glossinessMap, _MaterialSpecularGlossinessData_specular, _MaterialSpecularGlossinessData_specularGlossinessMap, _MaterialSpecularGlossinessData_specularMap;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialSpecularGlossinessData = void 0;
const AbstractMaterialData_1 = require("./AbstractMaterialData");
class MaterialSpecularGlossinessData extends AbstractMaterialData_1.AbstractMaterialData {
    // #endregion Properties (5)
    // #region Constructors (1)
    /**
     * Creates a material data object.
     *
     * @param _attributes the attributes of the material
     * @param id the id
     */
    constructor(properties, id) {
        super(properties, id);
        // #region Properties (5)
        _MaterialSpecularGlossinessData_glossiness.set(this, 1);
        _MaterialSpecularGlossinessData_glossinessMap.set(this, void 0);
        _MaterialSpecularGlossinessData_specular.set(this, '#ffffff');
        _MaterialSpecularGlossinessData_specularGlossinessMap.set(this, void 0);
        _MaterialSpecularGlossinessData_specularMap.set(this, void 0);
        if (!properties)
            return;
        if (properties.glossiness !== undefined)
            this.glossiness = properties.glossiness;
        if (properties.specular !== undefined)
            this.specular = properties.specular;
        if (properties.specularGlossinessMap !== undefined)
            this.specularGlossinessMap = properties.specularGlossinessMap;
        if (properties.specularMap !== undefined)
            this.specularMap = properties.specularMap;
        if (properties.glossinessMap !== undefined)
            this.glossinessMap = properties.glossinessMap;
    }
    // #endregion Constructors (1)
    // #region Public Accessors (10)
    get glossiness() {
        return __classPrivateFieldGet(this, _MaterialSpecularGlossinessData_glossiness, "f");
    }
    set glossiness(value) {
        __classPrivateFieldSet(this, _MaterialSpecularGlossinessData_glossiness, value, "f");
    }
    get glossinessMap() {
        return __classPrivateFieldGet(this, _MaterialSpecularGlossinessData_glossinessMap, "f");
    }
    set glossinessMap(value) {
        __classPrivateFieldSet(this, _MaterialSpecularGlossinessData_glossinessMap, value, "f");
    }
    get specular() {
        return __classPrivateFieldGet(this, _MaterialSpecularGlossinessData_specular, "f");
    }
    set specular(value) {
        __classPrivateFieldSet(this, _MaterialSpecularGlossinessData_specular, value, "f");
    }
    get specularGlossinessMap() {
        return __classPrivateFieldGet(this, _MaterialSpecularGlossinessData_specularGlossinessMap, "f");
    }
    set specularGlossinessMap(value) {
        __classPrivateFieldSet(this, _MaterialSpecularGlossinessData_specularGlossinessMap, value, "f");
    }
    get specularMap() {
        return __classPrivateFieldGet(this, _MaterialSpecularGlossinessData_specularMap, "f");
    }
    set specularMap(value) {
        __classPrivateFieldSet(this, _MaterialSpecularGlossinessData_specularMap, value, "f");
    }
    // #endregion Public Accessors (10)
    // #region Public Methods (1)
    reset() {
        this.alphaCutoff = 0;
        this.alphaMap = undefined;
        this.alphaMode = AbstractMaterialData_1.MATERIAL_ALPHA.OPAQUE;
        this.aoMap = undefined;
        this.aoMapIntensity = 1.0;
        this.bumpMap = undefined;
        this.bumpScale = 1.0;
        this.color = '#ffffff';
        this.emissiveMap = undefined;
        this.emissiveness = undefined;
        this.materialOutput = false;
        this.map = undefined;
        this.normalMap = undefined;
        this.normalScale = 1.0;
        this.opacity = 1.0;
        this.shading = AbstractMaterialData_1.MATERIAL_SHADING.SMOOTH;
        this.side = AbstractMaterialData_1.MATERIAL_SIDE.DOUBLE;
        this.glossiness = 1;
        this.specular = '#ffffff';
        this.specularGlossinessMap = undefined;
        this.specularMap = undefined;
        this.glossinessMap = undefined;
    }
    clone() {
        return new MaterialSpecularGlossinessData({
            alphaMap: this.alphaMap,
            alphaCutoff: this.alphaCutoff,
            alphaMode: this.alphaMode,
            aoMap: this.aoMap,
            aoMapIntensity: this.aoMapIntensity,
            bumpMap: this.bumpMap,
            bumpScale: this.bumpScale,
            color: this.color,
            emissiveMap: this.emissiveMap,
            emissiveness: this.emissiveness,
            shading: this.shading,
            map: this.map,
            name: this.name,
            normalMap: this.normalMap,
            normalScale: this.normalScale,
            opacity: this.opacity,
            side: this.side,
            specular: this.specular,
            specularMap: this.specularMap,
            specularGlossinessMap: this.specularGlossinessMap,
            glossiness: this.glossiness,
            glossinessMap: this.glossinessMap,
        }, this.id);
    }
    copy(source) {
        this.alphaCutoff = source.alphaCutoff;
        this.alphaMap = source.alphaMap;
        this.alphaMode = source.alphaMode;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.color = source.color;
        this.emissiveMap = source.emissiveMap;
        this.emissiveness = source.emissiveness;
        this.materialOutput = source.materialOutput;
        this.map = source.map;
        this.normalMap = source.normalMap;
        this.normalScale = source.normalScale;
        this.opacity = source.opacity;
        this.shading = source.shading;
        this.side = source.side;
        this.glossiness = source.glossiness;
        this.specular = source.specular;
        this.specularGlossinessMap = source.specularGlossinessMap;
        this.specularMap = source.specularMap;
        this.glossinessMap = source.glossinessMap;
    }
}
exports.MaterialSpecularGlossinessData = MaterialSpecularGlossinessData;
_MaterialSpecularGlossinessData_glossiness = new WeakMap(), _MaterialSpecularGlossinessData_glossinessMap = new WeakMap(), _MaterialSpecularGlossinessData_specular = new WeakMap(), _MaterialSpecularGlossinessData_specularGlossinessMap = new WeakMap(), _MaterialSpecularGlossinessData_specularMap = new WeakMap();
//# sourceMappingURL=MaterialSpecularGlossinessData.js.map